import React from "react";
import clsx from "clsx";
import Pagination from "react-js-pagination";

import styles from "./tablePagination.module.scss";

export const TablePagination = ({
	handlePageChange,
	page,
	count,
	wrapperClassName = "",
	...props
}) => (
	<div className={clsx(styles.footer, wrapperClassName)}>
		<span className={styles.totalRecords}>
			<span className="text-grey">Total Records: </span>
			<span>{count}</span>
		</span>
		<span className={styles.paging}>
			<Pagination
				hideFirstLastPages
				prevPageText="〈 PREV"
				nextPageText="NEXT 〉"
				className={styles.paginationPanel}
				//Server starts counting from 0
				activePage={page + 1}
				itemsCountPerPage={50}
				totalItemsCount={count}
				pageRangeDisplayed={1}
				onChange={handlePageChange}
				{...props}
			/>
		</span>
	</div>
);
